import TaskComment from "./cards/TaskComment";
import React, { useCallback, useEffect, useState } from "react";
import { BiSolidSend } from "react-icons/bi";
import styles from "./tables/table.module.css";
import { createPaperComment, createTaskComment, getAllTaskComments, getPaperComments } from "../api/Api";
import { showToast } from "../utils/toastUtils";

// generate color from string
const colors = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ('00' + value.toString(16)).slice(-2);
    }
    return color;
};

const TaskComments = ({
  options,
  stringToColor = colors,
  loadAll, // use in only task variant
  close,
  variant = "task", // variant: task, paper
  paperId, // use in only paper variant
}) => {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");

  //   load all messages for the task
  const loadAllMessages = useCallback(() => {
    getAllTaskComments(options.id).then((res) => {
      console.log(res);
      setComments(res?.data);
    }).catch((err) => {
        showToast("error", "Error", err.response.data.message);
    })
  }, [options.id]);

  // todo: implement this
  const loadAllPapers = useCallback(() => {
    getPaperComments(paperId).then((res) => {
      console.log(res);
      setComments(res?.data);
    }).catch((err) => {
        showToast("error", "Error", err.response.data.message);
    });
  }, [paperId]);

  useEffect(() => {
    switch (variant) {
      case "task":
        loadAllMessages();
        break;
      case "paper":
        loadAllPapers();
        break;
      default:
        console.warn(`Unknown variant: ${variant}`);
    }
  }, [variant]);

  // handle message on change
  const handleMessageOnChange = (e) => setMessage(e.target.value);

  // send comment on key enter
  const handleMessageOnKeyEnter = (e) => {
    if (e.key === "Enter") sendComment();
  };

  const sendComment = () => {
    if (message.trim() !== "") {
      const obj = {
        content: message,
      };

      switch (variant) {
        case "task":
          createTaskComment(options.id, obj).then((res) => {
            if (res.status === 201) {
              loadAllMessages();
              loadAll();
              setMessage("");
            }
          });
          break;

        //   todo implement this
        case "paper":
            createPaperComment(paperId, obj).then((res) => {
                if (res.status === 201) {
                    loadAllPapers();
                    setMessage("");
                }
            });
          break;
        default:
          console.warn(`Unknown variant: ${variant}`);
      }
    }
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="py-3 px-3 border-bottom sticky-top d-flex justify-content-between align-items-center">
        <span className="fw-semibold pe-2">{options.title}</span>

        <button onClick={close} className="btn btn-close"></button>
      </div>

      <div
        className={`flex-grow-1 overflow-auto py-2 ps-3 ${styles.styledScroll}`}
      >
        <div>
          <div className="overflow-auto mt-4">
            {comments?.map((item, index) => (
              <div key={index}>
                <TaskComment comment={item} stringToColor={stringToColor} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-2 pb-5 px-3 border-top sticky-bottom">
        <div className="d-flex align-items-center w-100">
          <input
            type="text"
            className={`form-control me-2 rounded-pill ${styles.commentInput}`}
            placeholder="Type something..."
            value={message}
            onChange={handleMessageOnChange}
            onKeyDown={handleMessageOnKeyEnter}
          />
          <button
            onClick={sendComment}
            className={`${styles.commentButton} btn btn-primary d-flex justify-content-center align-items-center h-100`}
          >
            <BiSolidSend />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskComments;
